import {stateUpdaterFn, stateUpdaterPartialFn} from '../react/stateUpdaterFn';

export const executeOrReturnAtomState = stateUpdaterFn;
export const executeOrReturnAtomPartialState = stateUpdaterPartialFn;
